export default "__VITE_ASSET__c4334429__"